import { createContext } from 'react'

export interface EmailVerificationContextType {
  showVerificationOverlay: boolean
  verificationEmail: string
  setVerificationEmail: (email: string) => void
  showVerificationOverlayHandler: (email: string) => void
  hideVerificationOverlay: () => void
  checkVerificationStatus: () => Promise<boolean>
}

export const EmailVerificationContext = createContext<EmailVerificationContextType | undefined>(undefined)
